// extracted by mini-css-extract-plugin
export var sbShowMain = "subheaderListLinks-module--sb-show-main--3wbsq";
export var subheaderListLinks = "subheaderListLinks-module--subheaderListLinks--Czpc2";
export var title = "subheaderListLinks-module--title--2PVLL";
export var linksContainer = "subheaderListLinks-module--linksContainer--2jnMA";
export var oneColumn = "subheaderListLinks-module--oneColumn--21pGb";
export var twoColumns = "subheaderListLinks-module--twoColumns--3Z9-i";
export var linkItemContainer = "subheaderListLinks-module--linkItemContainer--8O3dX";
export var linkItem = "subheaderListLinks-module--linkItem--Z2AuH";
export var link = "subheaderListLinks-module--link--1PBdN";